import { useState } from 'react'

const EFFECTS = [
  { id: 1, name: '星星闪烁', type: '粒子', preview: '' },
  { id: 2, name: '烟雾效果', type: '环境', preview: '🌫️' },
  { id: 3, name: '火花飞溅', type: '粒子', preview: '💥' },
  { id: 4, name: '雪花飘落', type: '天气', preview: '❄️' },
  { id: 5, name: '光晕效果', type: '光效', preview: '🌟' },
  { id: 6, name: '故障特效', type: '风格', preview: '💠' },
  { id: 7, name: '复古胶片', type: '风格', preview: '🎞️' },
  { id: 8, name: '模糊转场', type: '转场', preview: '🔄' },
]

export default function EffectsLibrary() {
  const [filter, setFilter] = useState('全部')

  const types = ['全部', ...new Set(EFFECTS.map(e => e.type))]

  const filtered = filter === '全部' ? EFFECTS : EFFECTS.filter(e => e.type === filter)

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>?特效?</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>视频制作可用的特效素材，支持实时预览</p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {types.map(t => (
          <button
            key={t}
            onClick={() => setFilter(t)}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: 20,
              cursor: 'pointer',
              fontSize: 13,
              background: filter === t ? '#1890ff' : '#f5f5f5',
              color: filter === t ? '#1890ff' : '#666'
            }}
          >
            {t}
          </button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 16 }}>
        {filtered.map(e => (
          <div key={e.id} style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', cursor: 'pointer' }}
            onMouseEnter={event => event.currentTarget.style.transform = 'scale(1.02)'}
            onMouseLeave={event => event.currentTarget.style.transform = 'scale(1)'}
          >
            <div style={{ height: 100, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>
              {e.preview}
            </div>
            <div style={{ padding: 12, textAlign: 'center' }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>{e.name}</div>
              <div style={{ fontSize: 11, color: '#999' }}>{e.type}</div>
              <button style={{ width: '100%', marginTop: 8, padding: '6px', background: '#fff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>应用</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
